// extracted by mini-css-extract-plugin
export default {"dayWrapper":"Day_dayWrapper__tPpJj","today":"Day_today__ONE0m"};